import { fetchWithAuth } from '../lib/fetchWithAuth';

const API_BASE_URL = import.meta.env.VITE_API_URL?.replace(/\/$/, '');

export type AdminAnalyticsStat = {
  label: string;
  value: number;
  delta: number;
};

export type AdminAnalyticsResponse = {
  stats: AdminAnalyticsStat[];
  charts: {
    weeklyActivity: Array<{ label: string; value: number }>;
    incidentHistory: Array<{ label: string; value: number }>;
  };
  backlog: {
    moderation: number;
    supportTickets: number;
    slaHours: number;
    p95Hours: number;
  };
  insights: string[];
};

export async function fetchAdminAnalytics(): Promise<AdminAnalyticsResponse> {
  if (!API_BASE_URL) {
    throw new Error('VITE_API_URL is required to load admin analytics.');
  }
  const response = await fetchWithAuth(`${API_BASE_URL}/v1/admin/analytics`);
  if (!response.ok) {
    const text = await response.text().catch(() => 'request failed');
    throw new Error(`Admin analytics fetch failed (${response.status}): ${text}`);
  }
  return (await response.json()) as AdminAnalyticsResponse;
}
